module.exports = __webpack_public_path__ + "static/media/confirmacao.ff09329d.svg";